// src/firebaseMessaging.js
import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

// Firebase config from console
const firebaseConfig = {
  apiKey: "AIzaSyC-t1g9aFZXyV4RAegN0Mhcs9srHwHau3A",
  authDomain: "yoga-8b8e8.firebaseapp.com",
  projectId: "yoga-8b8e8",
  storageBucket: "yoga-8b8e8.firebasestorage.app",
  messagingSenderId: "883553171238",
  appId: "1:883553171238:web:8279b059a16c741b16b3e7",
  measurementId: "G-KJN40HXFRE",
};

// Web Push public key from Firebase (the one you put in .env)
const VAPID_PUBLIC_KEY =
  "BBpeaobYPQupx72Ptqd-s47fmQ6Bv8_dVP62qHXa_7Kc4jnpFBHxzbdkU-wPy2rormRFuuCQaesoT7IBQB_k6sM";

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

// Ask permission and get FCM token
export async function getFcmToken() {
  try {
    if (!("Notification" in window)) {
      console.warn("Notifications not supported");
      return null;
    }

    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.warn("Notification permission:", permission);
      return null;
    }

    const token = await getToken(messaging, {
      vapidKey: VAPID_PUBLIC_KEY,
    });

    if (!token) {
      console.warn("No FCM token received");
      return null;
    }

    console.log("[FCM] token:", token);
    return token;
  } catch (err) {
    console.error("[FCM] getFcmToken error:", err);
    return null;
  }
}

// Optional: handle messages when tab is open
export function subscribeToForegroundMessages(callback) {
  onMessage(messaging, (payload) => {
    console.log("[FCM] foreground message:", payload);
    if (callback) callback(payload);
  });
}
